import { render, staticRenderFns } from "./BrokerAccount.vue?vue&type=template&id=1fb3ab86&scoped=true"
import script from "./BrokerAccount.vue?vue&type=script&lang=js"
export * from "./BrokerAccount.vue?vue&type=script&lang=js"
import style0 from "./BrokerAccount.vue?vue&type=style&index=0&id=1fb3ab86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb3ab86",
  null
  
)

export default component.exports